import { ADMappingModel } from "./ADMappingModel";

export class ActiveDirectoryAddEditModel {
  ID: number;
  ADConnectionTypeItemName: string;
  ValidationError_Duplicates: string;
  IsExistsCurrentDomain: boolean;
  Domain: string;
  ConnectionName: string;
  PermissionSetID: number;
  ADConnectionTypeItemID: number;
  Identifier: string;
  SamAccount: string;
  Password: string;
  ShowBuiltInGroups: boolean;
  ImagesFileProviderName: string;
  LangKey: string;
  MarkAsInactive: boolean;
  WelcomeTemplateID: number;
  AddToDailyJob: boolean;
  ADMappings: ADMappingModel[] = [];
}
